<script>
	import {onMount} from 'svelte';
	import Parallax from 'parallax-js';
	import Rock from "./Rock.svelte";

	const rocks = [
		{
			color: '#A56255',
			width: '50vmin',
			height: 'auto',
			maxWidth: '407px',
			minWidth: '159px',
			top: '-40vh',
			left: '-45vw',
			rotate: 'rotate(18deg)'
		},
		{
			color: '#BAA23C',
			width: '20vmin',
			height: 'auto',
			maxWidth: '207px',
			minWidth: '96px',
			top: '-50vh',
			left: '30vw',
			rotate: 'rotate(180deg)'
		},
		{
			color: '#565454',
			width: '15vmin',
			height: 'auto',
			maxWidth: '105px',
			minWidth: '95px',
			top: '23rem',
			left: '-24vw',
			rotate: 'rotate(0deg)'
		},
		{
			color: '#565454',
			width: '40vmin',
			height: 'auto',
			maxWidth: '471px',
			minWidth: '169px',
			top: '23rem',
			left: '45vw',
			rotate: 'rotate(180deg)'
		},
		{
			color: '#A56255',
			width: '17vmin',
			height: 'auto',
			maxWidth: '271px',
			minWidth: '112px',
			top: '-12rem',
			left: '40vw',
			rotate: 'rotate(0deg)'
		},
		{
			color: '#BAA23C',
			width: '22vmin',
			height: 'auto',
			maxWidth: '217px',
			minWidth: '88px',
			top: '14rem',
			left: '-37vw',
			rotate: 'rotate(180deg)'
		},
	];

	let scene;
	let parallaxedScene;

	onMount(() => {
		parallax();
	})

	let parallax = () => {
		if (parallaxedScene) {
			return;
		}

		parallaxedScene = new Parallax(scene);
	};
</script>

<div bind:this={scene} data-relative-input="true">
	{#each rocks as rock, index}
		<Rock {...rock} id="rock-{index}"/>
	{/each}
</div>

<style type="text/scss">
	/* Parallax.js layers have to inherit the size from its parent scene. */
	div {
		height: 100%;
		left: 0;
		overflow: hidden;
		position: absolute !important;
		top: 0;
		width: 100%;
		z-index: 3;
	}
</style>
